import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

function TeamPlayers() {
    const { teamId } = useParams();
    const [players, setPlayers] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/stats/team/${teamId}/players/`) // Updated API URL
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => setPlayers(data))
            .catch((err) => setError(err.message));
    }, [teamId]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <h1>Players</h1>
            <ul>
                {players.map((player) => (
                    <li key={player.id}>
                        <Link to={`/player/${player.id}`}>{player.name}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default TeamPlayers;
